import axios from 'axios'
import { call } from 'file-loader'
import moment from 'moment'
// var callback;

var http = axios.create({
  baseURL: process.env.API_BASE_URL,
  headers: {'Content-Type': 'application/json'},
})

var httpupload = axios.create({
    baseURL: process.env.API_BASE_URL,
    headers: {'Content-Type': 'multipart/form-data'},
  })

http.interceptors.response.use(function (response) {
  return response
}, function (error) {
  if (error.response.status !== 401) return Promise.reject(error)

  var refreshAndRetry = new Promise(function (resolve) {
    axios.post(process.env.API_BASE_URL + '/account/refresh_token',
    {
      'refresh_token': JSON.parse(localStorage.getItem('refresh_token')).value
    },
    {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + JSON.parse(localStorage.getItem('token')).value
      }
    }).then(function (response) {
      localStorage.setItem('refresh_token', JSON.stringify({
        value: response.data.refresh_token,
        expire: null
      }))

      localStorage.setItem('token', JSON.stringify({
        value: response.data.token,
        expire: null
      }))

      return Promise.resolve(response)
    }).then(function (response) {
      var failedRequest = error.config
      failedRequest.headers.Authorization = 'Bearer ' + JSON.parse(localStorage.getItem('token')).value
      axios.request(failedRequest).then(function (retryResponse) {
        resolve(retryResponse)
      })
    })
  })

  return refreshAndRetry
})

function getConfig()
{
  return {
    headers: {
      'Authorization': JSON.parse(localStorage.getItem('token')).value
    }
  }
}

function getConfigAffiliate(callback) {
    var config = getConfig()
  
    http.get('/sales/configs', config)
      .then(function (response) {
        callback({
          success: true,
          data: response.data
        })
      }).catch(function (error) {
        callback({
          success: false,
          message: error.message
        })
      })
  }

//   function getProductAffiliate (callback) {
//     var config = getConfig()
  
//     http.get('/sales/products', config)
//       .then(function (response) {
//         callback({
//           success: true,
//           data: response.data
//         })
//       }).catch(function (error) {
//         callback({
//           success: false,
//           message: error.message
//         })
//       })
//   }

  function saveConfig (dataBody, callback)
  {
    var config = getConfig()

    http.put('/sales/configs', dataBody, config)
      .then(function (response) {
        callback({
          success: true,
          data: response.data
        })
      }).catch(function (error) {
        callback({
          success: false,
          message: error.message
        })
      })
  }

  function updateProduct (dataBody, callback) {
    var config = getConfig()
    dataBody.persentate_commission = parseInt(dataBody.persentate_commission)
    http.put('/sales/product/'+ dataBody.id, dataBody, config)
      .then(function (response) {
        callback({
          success: true,
          data: response.data
        })
      }).catch(function (error) {
        callback({
          success: false,
          message: error.message
        })
      })
  }

  function getRedeemList(params, callback) {
    var config = getConfig()
    let query = ''
    // start_date: null,
    //     end_date: null,
    //     wallet_type: '',
    //     status: '',
    //     page_size: '',
    //     page: 0,
    //     sort_mode: 'ASC',
    //     page_size: 10
    if(params.page !== '') query += 'page=' + params.page
    if(params.start_date !== null && params.start_date !== '') query += '&started_date=' + (moment(params.start_date, "DD/MM/YYYY").valueOf() / 1000)
    if(params.end_date !== null && params.end_date !== '') query += '&ended_date=' + (moment(params.end_date, "DD/MM/YYYY").valueOf() / 1000 + 86100)
    if(params.wallet_type !== '') query += '&wallet_type=' + params.wallet_type
    if(params.status !== '') query += '&status=' + params.status
    if(params.page_size !== '') query += '&page_size=' + params.page_size
    if(params.search !== '') query += '&search=' + params.search
    if(params.sort_mode !== '') query += '&sort_mode=' + params.sort_mode


    http.get('/sales/affiliate/redeems?' + query, config)
      .then(function (response) {
        callback({
          success: true,
          data: response.data
        })
      }).catch(function (error) {
        callback({
          success: false,
          message: error.message
        })
      })
  }

  function getRedeemStatus(callback) {
    var config = getConfig()
  
    http.get('/sales/affiliate/redeem/status', config)
      .then(function (response) {
        callback({
          success: true,
          data: response.data
        })
      }).catch(function (error) {
        callback({
          success: false,
          message: error.message
        })
      })
  }

  function getRedeemWallets(callback) {
    var config = getConfig()
  
    http.get('/sales/affiliate/redeem/wallets', config)
      .then(function (response) {
        callback({
          success: true,
          data: response.data
        })
      }).catch(function (error) {
        callback({
          success: false,
          message: error.message
        })
      })
  }

  function getDetailRedeem(id,callback) {
    var config = getConfig()
  
    http.get('/sales/affiliate/redeem/' + id, config)
      .then(function (response) {
        callback({
          success: true,
          data: response.data
        })
      }).catch(function (error) {
        callback({
          success: false,
          message: error.message
        })
      })
  }

  function updateStatusRedeem (dataBody, callback) {
    var config = getConfig()
    http.put('/sales/affiliate/redeem/'+ dataBody[0], dataBody[1], config)
      .then(function (response) {
        callback({
          success: true,
          data: response.data
        })
      }).catch(function (error) {
        callback({
          success: false,
          message: error.message
        })
      })
  }

  function getDataDashboardAffiliate (params, callback) {
    var config = getConfig()
    let query = '?'
    console.log(params)
    
    if(params.start_date !== null && params.start_date !== '') query += 'started_date=' + (moment(params.start_date, "DD/MM/YYYY").valueOf() / 1000);
    if(params.end_date !== null && params.end_date !== '') query += '&ended_date=' + (moment(params.end_date, "DD/MM/YYYY").valueOf() / 1000 + 86100);


    http.get('/sales/affiliate/dashboard' + query, config)
      .then(function (response) {
        callback({
          success: true,
          data: response.data
        })
      }).catch(function (error) {
        callback({
          success: false,
          message: error.message
        })
      })
  }

  function getListAffiliator (params, callback){
    var config = getConfig()
    let query = '?'
    // if(params.start_date !== null && params.start_date !== '') query += 'start_date=' + moment(params.start_date).unix();
    // if(params.end_date !== null && params.end_date !== '') query += '&end_date=' + moment(params.end_date).unix();
    if(params.page !== null && params.page !== '') query += 'page=' + params.page;
    if(params.page_size !== null && params.page_size !== '') query += '&page_size=' + params.page_size;
    if(params.search !== null && params.search !== '') query += '&search=' + params.search;
    if(params.sort_by !== null && params.sort_by !== '') query += '&sort_by=' + params.sort_by;
    if(params.sort_mode !== null && params.sort_mode !== '') query += '&sort_mode=' + params.sort_mode;

    http.get('/sales/affiliate/members' + query, config)
      .then(function (response) {
        callback({
          success: true,
          data: response.data
        })
      }).catch(function (error) {
        callback({
          success: false,
          message: error.message
        })
      })
  }
  
export default
{
    getConfigAffiliate,
    getRedeemList,
    saveConfig,
    updateProduct,
    getDetailRedeem,
    updateStatusRedeem,
    getRedeemWallets,
    getRedeemStatus,
    getDataDashboardAffiliate,
    getListAffiliator
}



// WEBPACK FOOTER //
// ./src/services/affiliate.js